import React, { Component } from "react";
import "./MALab.css";
class MALabLogo extends Component {
    render() {
        return (<React.Fragment>
        <img src="./symptom.jpg"/>

        {/* <div> */}
        {/* </div> */}
      </React.Fragment>);
    }
}
export default MALabLogo;